// import React, {
//   memo,
//   useCallback,
//   useContext,
//   useEffect,
//   useState,
// } from "react";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
// import { Link } from "react-router-dom";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { getRawPermissionsArray } from "../../../../Routes/AuthGard/usePermissions";
// import {
//   deleteFeedPost,
//   feedPostComment,
//   getFeed,
//   getReportPost,
//   feedLikePost,
//   postMarkFeatured,
//   postMarkUnFeatured,
//   feedLikeList,
//   postFeed,
// } from "../Services/DashboardServices";
// import moment from "moment";
// import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
// import { TostMsg } from "../../../../App";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
// import InfiniteScroll from "react-infinite-scroll-component";
// import FeedPost from "./FeedPost";
// import { PostDate } from "../CommonComponents/PostDate";
// import Commnent from "../../../../Services/Comment/comment";
// import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
// import "react-loading-skeleton/dist/skeleton.css";
// import Skeleton from "react-loading-skeleton";
// import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
// import { setFeedRequestData } from "../../../../Services/Redux/DataTransferToAnother";
// import { useDispatch, useSelector } from "react-redux";
// import TosterService from "../../../../Services/Toster-Service/TosterService";
// import { Editor } from "primereact/editor";
// import { debounce } from "lodash";
// import { getTrans as T } from "../../../../Shared/Language";
// import LoginLoader from "../../../../Shared/Sidebar/LoginLoader";
// import DashboardTask from "../CommonComponents/DashboardTask";
// const FeedCarousel = React.lazy(() =>
//   import("./FeedCarousel").then((module) => ({ default: module.FeedCarousel })),
// );
// const defaultImage = "/images/placeholder_profile.png";

// let MakeFeaturedFeedId;
// let isFeaturedType;
// const DashboardFeed = memo(({ activityData = {}, loading: propLoading = false }) => {


//   let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
//   let history = useHistory();
//   const toaster = useContext(TostMsg);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isSecondLoading, setSecondLoading] = useState(false);
//   const [feedLst, setFeedLst] = useState([]);
//   const [employee, setEmployee] = useState([]);
//   const [feedText, setFeedText] = useState("");
//   const [postFile, setPostFile] = useState(null);
//   const [uploadedPostImages, setUploadedPostImages] = useState([]);
//   const [feedId, setFeedId] = useState(0);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [isFetching, setIsFetching] = useState(false);
//   let userPermissions = getRawPermissionsArray();
//   const [feedEdit, setFeedEdit] = useState(false);
//   const [feedReport, setFeedReport] = useState(false);
//   const [feedDelete, setFeedDelete] = useState(false);
//   const [feedFeatured, setFeedFeatured] = useState(false);
//   const [editFeedLst, setEditFeedLst] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);
//   const [currentTime, setCurrentTime] = useState(new Date());
//   const dispatch = useDispatch();
//   const toster = useContext(TostMsg);
//   const [feedArticelText, setFeedArticelText] = useState("");
//   const [editFeedArticleId, setEditFeedArticleId] = useState("");
//   const [isVisible, setIsVisible] = useState(false);
//   const [dashboardFeedPost, setDashboardFeedPost] = useState(false);
//   const [dashboardFeedRead, setDashboardFeedRead] = useState(false);
//   const [dashboardTaskRead, setDashboardTaskRead] = useState(false);
//   const [isVisibleFeedPost, setIsVisibleFeedPost] = useState(false);
//   const SideBarFeedRequestData = useSelector(
//     (state) => state.createPostData.postRequestData,
//   );

//   useEffect(() => {
//     if (SideBarFeedRequestData?.StatusCode === 2000) {
//       GetFeed(true);
//     }
//     fetchData();
//     FeedLikeListData();
//     permissionFeedGranted();
//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [SideBarFeedRequestData]);

//   useEffect(() => {
//     if (editFeedArticleId?.FeedText) {
//       setIsVisible(true);
//     } else if (feedArticelText) {
//       setIsVisible(true);
//     } else {
//       setIsVisible(false);
//     }
//   }, [editFeedArticleId, feedArticelText]);

//   const handleClickOutside = (event) => {
//     if (!event.target.closest(".dropdown")) {
//       setVisibleId(null);
//     }
//   };

//   const handleImageError = useCallback((event) => {
//     event.target.src = defaultImage;
//   }, []);

//   const handalClosePopup = () => {
//     document.querySelector("#report-img .btn-close")?.click();
//     reportPostForm.resetForm();
//   };

//   const addReportPost = () => {
//     reportPostForm.resetForm();
//   };

//   const handleDeleteImage = (uploadedPostImages) => {
//     setUploadedPostImages([]);
//   };

//   const handleResponseFromB = (response) => {
//     if (response) {
//       setFeedLst([]);
//       setPage(1);
//       setHasMore(true);
//       dispatch(setFeedRequestData(response));
//       GetFeed(true);
//     }
//   };

//   const fetchData = async () => {
//     await GetFeed(false);
//     await fetchEmployeeData();
//   };

//   const [visibleId, setVisibleId] = useState(null);
//   const toggleVisibility = (id) => {
//     setVisibleId((prevId) => (prevId === id ? null : id));
//   };

//   const handleLastName = (lst, type) => {
//     setFeedLst((prevFeed) =>
//       prevFeed.map((post) => {
//         if (post.Id !== lst.Id) return post;

//         const reactionsArray = post.Reactions
//           ? post.Reactions.toString().split(",")
//           : [];

//         // REMOVE reaction (toggle off)
//         if (post.MyReaction === type) {
//           return {
//             ...post,
//             MyReaction: "",
//             Reactions: reactionsArray.filter((r) => r !== type),
//             LikesCount: post.LikesCount - 1,
//             IsLikedByMe: 0,
//           };
//         }

//         // ADD first reaction
//         if (!post.MyReaction) {
//           return {
//             ...post,
//             MyReaction: type,
//             Reactions: [...reactionsArray, type],
//             LikesCount: post.LikesCount + 1,
//             IsLikedByMe: 1,
//           };
//         }

//         // CHANGE reaction
//         const updatedReactions = reactionsArray.map((r) =>
//           r === post.MyReaction ? type : r,
//         );

//         return {
//           ...post,
//           MyReaction: type,
//           Reactions: updatedReactions,
//         };
//       }),
//     );
//   };

//   async function GetFeed(reset = false) {
//     if (isFetching) return;
//     setIsFetching(true);
//     if (reset) {
//       setIsLoading(true);
//     } else {
//       setSecondLoading(true);
//     }
//     const body = {
//       OrgId: userDetails?.OrgId,
//       EmpId: 0,
//       EmpGUID: "",
//       FeedId: 0,
//       FeedGUID: "",
//       IsFeatures: 0,
//       pageNumber: reset ? 1 : page,
//       pageSize: 25,
//       LoggedInUserId: userDetails?.EmpId,
//     };

//     try {
//       const Feedlst = await getFeed(body);
//       const feedlist =
//         Feedlst?.Data?.map((el) => ({ ...el, isChecked: !!el.IsFeatures })) ||
//         [];
//       if (reset) {
//         setFeedLst(feedlist);
//         setPage(2);
//         setHasMore(feedlist.length === 25);
//       } else {
//         setFeedLst((prev) => [...prev, ...feedlist]);
//         setPage((prev) => prev + 1);
//         setHasMore(feedlist.length === 25);
//       }
//     } catch (error) {
//       toaster.current.error(ERROR_LIST?.DashboardFeed);
//     } finally {
//       setIsFetching(false);
//       setIsLoading(false);
//       setSecondLoading(false);
//     }
//   }

//   async function DeleteFeedPost() {
//     if (!deleteId || isNaN(deleteId)) {
//       toaster.current.error("Invalid feed ID for deletion.");
//       return;
//     }

//     const previousFeedLst = [...feedLst];
//     setFeedLst((prev) => {
//       const newList = prev.filter((item) => item.Id !== deleteId);
//       return newList;
//     });

//     try {
//       const body = { Id: deleteId };
//       await deleteFeedPost(body);
//       dispatch(setFeedRequestData(body));
//       toaster.current.success("Feed deleted successfully.");
//       setDeleteId(null);
//     } catch (error) {
//       toaster.current.error("Failed to delete feed post.");
//       setFeedLst(previousFeedLst);
//     }
//   }

//   async function fetchEmployeeData() {
//     var params = {
//       OrganisationId: userDetails?.OrgId,
//       LoggedInEmployeeId: userDetails?.EmpId,
//       IsDirectReportOrHierarchy: 0,
//       SearchText: "",
//       FollowersOnly: 0,
//       FollowingsOnly: 0,
//       IsExEmployeesAlso: 0,
//       pageNumber: 1,
//       pageSize: 5000000,
//       EmployeeId: 0,
//     };
//     try {
//       let employeesList// = await getEmployeeList(params);
//       setEmployee(employeesList.Data);
//     } catch (error) { }
//   }

//   async function FeedPostComment(Feedlst, mentionedArr, CommentText, FeedId) {
//     if (FeedId) {
//       const body = {
//         FeedId: FeedId,
//         EmpId: userDetails?.EmpId,
//         ParentCommentId: 0,
//         Comment: CommentText,
//         PostMentions: mentionedArr,
//       };

//       try {
//         await feedPostComment(body);
//         setFeedLst((prev) =>
//           prev.map((item, idx) =>
//             item.Id === FeedId
//               ? {
//                 ...item,
//                 LastComment: CommentText,
//                 LastCommentBy: userDetails?.FullName,
//                 LastCommentById: userDetails?.EmpId,
//                 LastCommentByProfilePic: userDetails?.ProfileImage,
//                 LastCommentDate: currentTime,
//                 LastCommentGUID: userDetails?.GUID,
//                 PostMentions: mentionedArr,
//                 TotalComments: item.TotalComments + 1,
//               }
//               : idx === feedLst?.findIndex((f) => f.FeedId === FeedId)
//                 ? { ...item, LastComment: CommentText }
//                 : item,
//           ),
//         );
//         setFeedText("");
//         setPage(1);
//         setHasMore(true);
//       } catch (error) {
//         toaster.current.error(ERROR_LIST?.FeedPostOnComment);
//       }
//     } else {
//       toaster.current.error(ERROR_LIST?.FeedPostOnComment);
//     }
//   }

//   const reportPostValidation = Yup.object().shape({
//     subject: Yup.string().required("Subject name is required."),
//     desc: Yup.string().required("Title desc is required."),
//     url: Yup.string(),
//   });

//   const reportPostForm = useFormik({
//     initialValues: {
//       subject: "",
//       desc: "",
//       url: "",
//     },
//     validationSchema: reportPostValidation,
//     onSubmit: async (data) => {
//       setIsLoading(true);
//       data.PostId = feedId ?? 0;
//       data.EmpId = userDetails?.EmpId;
//       let reportPostList = await getReportPost(data);
//       try {
//         if (reportPostList) {
//           reportPostForm.resetForm();
//           setUploadedPostImages([]);
//           toaster.current.success("Report post successfully");
//           handalClosePopup();
//           document.querySelector("#report-img .btn-close")?.click();
//           setIsLoading(false);
//         }
//       } catch (error) {
//         toaster.current.error("Something went wrong");
//         setIsLoading(false);
//       }
//     },
//   });

//   const handleFilePostChange = useCallback(async (event) => {
//     const selectedFile = await event.target.files[0];
//     setPostFile(selectedFile);
//   }, []);

//   const EditFeedLst = (feedLst) => {
//     setIsVisibleFeedPost(true);
//     setEditFeedLst(null);
//     setTimeout(() => setEditFeedLst(feedLst), 0);
//   };

//   const ResetFeedFields = () => {
//     setEditFeedLst(null);
//     setTimeout(() => setEditFeedLst("reset"), 0);
//   };
//   useEffect(() => {
//     if (postFile) {
//       uploadPostDocFile();
//     }
//   }, [postFile]);

//   async function uploadPostDocFile() {
//     if (postFile) {
//       setIsLoading(true);
//       const formData = new FormData();
//       formData.append("files", postFile);
//       let params = {
//         UploadType: UploadFile_KEYS?.Feed,
//         RefId: editFeedLst?.Id ?? 0,
//       };
//       const response = await await uploadDoc(params, formData);
//       const data = await response;
//       const postFormData = data?.Data[0];
//       setUploadedPostImages(data?.Data[0]);
//       reportPostForm.setFieldValue("url", postFormData);
//       setIsLoading(false);
//     } else {
//       toaster.current.warn("No file selected");
//       setIsLoading(false);
//     }
//   }

//   async function FeedLikePost(lst) {
//     const updatedFeedList = feedLst.map((item) => {
//       if (item.Id !== lst.Id) return item;
//       let updatedItem = { ...item };
//       if (item.IsLastCommentLikedByMe == 1) {
//         updatedItem = {
//           ...item,
//           IsLastCommentLikedByMe: Math.max(0, item.IsLastCommentLikedByMe - 1),
//           LastCommentLikeCount: Math.max(0, item.LastCommentLikeCount - 1),
//         };
//       } else {
//         updatedItem = {
//           ...item,
//           IsLastCommentLikedByMe: item.IsLastCommentLikedByMe + 1,
//           LastCommentLikeCount: item.LastCommentLikeCount + 1,
//         };
//       }
//       return updatedItem;
//     });
//     setFeedLst(updatedFeedList);
//     let isLike = lst.MyReaction !== "Like";
//     const body = {
//       FeedId: Number(lst.Id),
//       CommentId: lst.LastCommentId || 0,
//       ReactionById: userDetails?.EmpId,
//       ReactionTypeId: 101,
//       Reaction: "Like",
//       IsLike: isLike,
//     };
//     try {
//       await feedLikePost(body);
//     } catch (error) {
//       toaster.current.warn(ERROR_LIST.DashboardLike);
//     }
//   }

//   const renderFeedText = (text) => {
//     const mentionRegex = /@\w+/g;
//     const hashtagRegex = /#\w+/g;
//     let postMention = text?.PostMentions;
//     let FeedText = text?.LastComment;

//     let newText = FeedText?.replace(mentionRegex, (mention) => {
//       let matchedMention = postMention?.find(
//         (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention,
//       );
//       if (!matchedMention) {
//         return mention.replace("@", "");
//       }
//       return `<a href="/Profile/${matchedMention.MentionedUserId}">${matchedMention.MentionedName}</a>`;
//     });

//     newText = newText?.replace(hashtagRegex, (hashtag) => {
//       return `<a style="color: #c4c6c7">${hashtag}</a>`;
//     });

//     return { __html: newText };
//   };

//   function markFeatured(feedId, type) {
//     MakeFeaturedFeedId = feedId;
//     isFeaturedType = type;
//   }

//   async function PostMarkFeatured() {
//     setIsLoading(true);
//     const body = {
//       PostId: MakeFeaturedFeedId,
//     };
//     try {
//       await postMarkFeatured(body);
//       history?.push("/Feed/Featured");
//       setIsLoading(false);
//     } catch (error) {
//       setIsLoading(false);
//       toaster.current.error(ERROR_LIST?.MakeFeatured);
//     }
//   }

//   function markUnFeatured(feedId, type) {
//     MakeFeaturedFeedId = feedId;
//     isFeaturedType = type;
//   }

//   async function PostMarkUnFeatured() {
//     const previousFeedLst = [...feedLst];
//     setFeedLst((prev) => {
//       const newList = prev.map((item) => {
//         if (item.Id === MakeFeaturedFeedId) {
//           return {
//             ...item,
//             IsFeatured: 0,
//           };
//         }
//         return item;
//       });
//       return newList;
//     });
//     const body = {
//       PostId: MakeFeaturedFeedId,
//     };
//     try {
//       await postMarkUnFeatured(body);
//     } catch (error) {
//       setFeedLst(previousFeedLst);
//       toaster.current.error(ERROR_LIST?.MakeFeatured);
//     }
//   }

//   const permissionFeedGranted = () => {
//     userPermissions?.map((UserPermission) => {
//       if (UserPermission.PermissionName == "Feed.Edit") {
//         setFeedEdit(true);
//       } else if (UserPermission.PermissionName == "Feed.Report") {
//         setFeedReport(true);
//       } else if (UserPermission.PermissionName == "Feed.Delete") {
//         setFeedDelete(true);
//       } else if (UserPermission.PermissionName == "Feed.Featured") {
//         setFeedFeatured(true);
//       } else if (UserPermission.PermissionName == "Feed.Read") {
//         setDashboardFeedRead(true);
//       } else if (UserPermission.PermissionName == "Feed.Post") {
//         setDashboardFeedPost(true);
//       }
//       else if (UserPermission.PermissionName == "Task.Read") {
//         setDashboardTaskRead(true);
//       }
//     });
//   };

//   async function FeedLikeListData() {
//     const body = {
//       LoggedInUserId: userDetails?.EmpId,
//       FeedId: 438,
//       FeedGUID: "",
//       CommentId: 10198, //10198,
//       pageNumber: 1,
//       pageSize: 1000000,
//     };
//     try {
//       let LikeList = await feedLikeList(body);
//     } catch (error) {
//       TosterService.current.error(ERROR_LIST?.FeedLikePostOnFeedDetails);
//     }
//   }

//   const EditFeedArticleLst = (feedLst) => {
//     const modal = new window.bootstrap.Modal(
//       document.getElementById("add-Publish"),
//     );
//     modal.show();
//     if (feedLst) {
//       let cleanText = feedLst?.FeedText || "";
//       if (cleanText.startsWith("EditorContent=")) {
//         cleanText = cleanText.replace("EditorContent=", "");
//       }
//       const editArticle = {
//         Id: feedLst?.Id ?? 0,
//         EmpId: feedLst?.EmpId,
//         FeedText: feedLst?.FeedText,
//       };
//       setEditFeedArticleId(editArticle);
//       setFeedArticelText(cleanText);
//     }
//   };

//   const PostFeed = async () => {
//     setIsLoading(true);
//     //  const finalText = `EditorContent=${feedArticelText || editFeedArticleId?.FeedText || ""}`;
//     const text = feedArticelText || editFeedArticleId?.FeedText || "";
//     const finalText = text.startsWith("EditorContent=")
//       ? text
//       : `EditorContent=${text}`;
//     const body = {
//       Id: editFeedArticleId?.Id ?? 0,
//       EmpId: userDetails?.EmpId,
//       FeedText: finalText,
//       IsCommentEnabled: true,
//       IsLikeCountVisible: true,
//       CommentVisible: true,
//       IsLikeEnabled: true,
//       PostMedia: [],
//       PostMentions: [],
//     };
//     try {
//       await postFeed(body);
//       document.querySelector("#add-Publish .btn-close")?.click();
//       toster.current.success("Feed post successfully.");
//       GetFeed(false);
//       setFeedArticelText("");
//       setEditFeedArticleId("");
//       setIsLoading(false);
//     } catch (error) {
//       setIsLoading(false);
//       toster.current.error(ERROR_LIST?.DashboardFeaturePost);
//     }
//   };

//   const goToPost = (feedlst) => {
//     history.push(`/Feed/Post/${feedlst?.GUID}`);
//   };

//   return (
//     <div>

//       {dashboardFeedPost && (
//         <div
//           className="col-xl-12 topmedia-section mb-3"
//           onClick={() => ResetFeedFields()}
//         >
//           <div className="" onClick={(e) => { e.stopPropagation(); setIsVisibleFeedPost(true); }}>
//             <div className="feed-seach-div">
//               <div
//                 className="left-profile-div"
//                 style={{ cursor: "pointer" }}
//               >
//                 <img
//                   src={userDetails?.ProfileImage || defaultImage}
//                   onError={handleImageError}
//                   width="32"
//                   data-demo-src="/images/main-body/1.jpg"
//                 />
//                 <div className="feed-search">
//                   <span className="time">Share your thoughts</span>
//                 </div>
//               </div>
//               <div className="right-action-div">
//                 <ul className="edit-feeds">
//                   <li
//                     style={{ cursor: "pointer" }}
//                   >
//                     <svg
//                       stroke="currentColor"
//                       fill="currentColor"
//                       strokeWidth="0"
//                       viewBox="0 0 16 16"
//                       className="text-success pe-2"
//                       height="20"
//                       width="20"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"></path>
//                     </svg>
//                     Photos
//                   </li>
//                   <li
//                     style={{ cursor: "pointer" }}
//                   >
//                     <svg
//                       stroke="currentColor"
//                       fill="currentColor"
//                       strokeWidth="0"
//                       viewBox="0 0 16 16"
//                       className="text-info pe-2"
//                       height="20"
//                       width="20"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"></path>
//                       <path d="M9 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6"></path>
//                       <path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"></path>
//                     </svg>
//                     Videos
//                   </li>
//                   <li
//                     style={{ cursor: "pointer" }}
//                   >
//                     <svg
//                       stroke="currentColor"
//                       fill="currentColor"
//                       strokeWidth="0"
//                       viewBox="0 0 16 16"
//                       className="text-warning pe-2"
//                       height="20"
//                       width="20"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"></path>
//                     </svg>
//                     Feelings
//                   </li>
//                   {/* <li
//                   data-bs-toggle="modal"
//                   data-bs-target="#add-Publish"
//                   style={{ cursor: "pointer" }}
//                   onClick={() => setFeedArticelText("")}
//                 >
//                   <svg
//                     stroke="currentColor"
//                     fill="currentColor"
//                     strokeWidth="0"
//                     viewBox="0 0 16 16"
//                     className="text-warning pe-2"
//                     height="20"
//                     width="20"
//                     data-bs-toggle="modal"
//                     data-bs-target="#add-Publish"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path d="M15.964.686a.5.5 0 0 0-.69-.69L.767 7.247a.5.5 0 0 0 .07.92l5.632 2.11 2.11 5.632a.5.5 0 0 0 .92.07z" />
//                   </svg>
//                   Publish
//                 </li> */}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {dashboardTaskRead && <DashboardTask activityData={activityData} loading={propLoading}  />}

//       {isVisibleFeedPost && (
//         <FeedPost
//           returnResponce={handleResponseFromB}
//           editFeedLst={editFeedLst}
//           onClose={() => setIsVisibleFeedPost(false)}
//           // isModelPopupOpen={true}
//         />
//       )}

//       {dashboardFeedRead && (
//         <>
//           {isLoading ? (
//             <Skeleton height={470} width="100%" />
//           ) : (
//             <InfiniteScroll
//               dataLength={feedLst?.length || 0}
//               next={() => GetFeed(false)}
//               hasMore={hasMore}
//               scrollableTarget="scrollableDiv"
//             >
//               {feedLst?.map((feedlst, index) => (
//                 <div className="col-xl-12" key={index}>
//                   <div
//                     className=""
//                     style={{ background: "none", boxShadow: "none" }}
//                   >
//                     <div className="">
//                       <div
//                         id="feed-post-1"
//                         className="card is-post"
//                         onClick={() => goToPost(feedlst)}
//                       >
//                         <div className="content-wrap">
//                           <div className="card-heading">
//                             <div
//                               id="myDIV2"
//                               style={{
//                                 display:
//                                   visibleId === feedlst.Id ? "block" : "none",
//                               }}
//                             >
//                               {(feedEdit ||
//                                 feedlst?.CreatedBy == userDetails?.EmpId) && (
//                                   <a
//                                     className="dropdown-item"
//                                     style={{ cursor: "pointer" }}
//                                     onClick={() =>
//                                       feedlst?.FeedText?.includes("EditorContent=")
//                                         ? EditFeedArticleLst(feedlst)
//                                         : EditFeedLst(feedlst)
//                                     }
//                                     // onClick={() => EditFeedLst(feedlst)}
//                                     aria-expanded="false"
//                                     data-toggle="tooltip"
//                                     data-placement="right"
//                                     title="Edit"
//                                   >
//                                     <div className="media">
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="16"
//                                         height="16"
//                                         fill="currentColor"
//                                         className="bi bi-pencil-square"
//                                         viewBox="0 0 16 16"
//                                       >
//                                         <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
//                                         <path
//                                           fillRule="evenodd"
//                                           d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
//                                         />
//                                       </svg>
//                                       <div className="media-content">
//                                         <h3>Edit</h3>
//                                       </div>
//                                     </div>
//                                   </a>
//                                 )}
//                               {(feedDelete ||
//                                 feedlst?.CreatedBy == userDetails?.EmpId) && (
//                                   <a
//                                     style={{ cursor: "pointer" }}
//                                     className="dropdown-item"
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#delete-post"
//                                     onClick={() => setDeleteId(feedlst?.Id)}
//                                   >
//                                     <div className="media">
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="16"
//                                         height="16"
//                                         fill="currentColor"
//                                         className="bi bi-trash"
//                                         viewBox="0 0 16 16"
//                                         title="Delete"
//                                       >
//                                         <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
//                                         <path
//                                           fillRule="evenodd"
//                                           d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
//                                         />
//                                       </svg>
//                                       <div className="media-content">
//                                         <h3>Delete</h3>
//                                       </div>
//                                     </div>
//                                   </a>
//                                 )}
//                               {feedlst?.CreatedBy !== userDetails?.EmpId &&
//                                 feedReport && (
//                                   <a
//                                     style={{ cursor: "pointer" }}
//                                     className="dropdown-item"
//                                     data-bs-toggle="modal"
//                                     data-bs-target="#report-img"
//                                     onClick={() => {
//                                       setFeedId(feedlst?.Id);
//                                       addReportPost();
//                                     }}
//                                   >
//                                     <div className="media">
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="16"
//                                         height="16"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         strokeWidth="2"
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         className="feather feather-flag mr-2"
//                                         title="Report"
//                                       >
//                                         <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
//                                         <line x1="4" y1="22" x2="4" y2="15"></line>
//                                       </svg>
//                                       <div className="media-content">
//                                         <h3>Report this post</h3>
//                                       </div>
//                                     </div>
//                                   </a>
//                                 )}
//                               {feedFeatured && feedlst?.IsFeatured === 0 && (
//                                 <a
//                                   style={{ cursor: "pointer" }}
//                                   className="dropdown-item"
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#featured-post"
//                                   onClick={() => markFeatured(feedlst?.Id, 1)}
//                                 >
//                                   <div className="media">
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       width="16"
//                                       height="16"
//                                       fill="currentColor"
//                                       className="bi bi-file-earmark-check"
//                                       viewBox="0 0 16 16"
//                                       title="Featured"
//                                     >
//                                       <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
//                                       <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
//                                     </svg>
//                                     <div className="media-content">
//                                       <h3>Mark as Featured</h3>
//                                     </div>
//                                   </div>
//                                 </a>
//                               )}
//                               {feedFeatured && feedlst?.IsFeatured === 1 && (
//                                 <a
//                                   style={{ cursor: "pointer" }}
//                                   className="dropdown-item"
//                                   data-bs-toggle="modal"
//                                   data-bs-target="#featured-post"
//                                   onClick={() => markUnFeatured(feedlst?.Id, 2)}
//                                 >
//                                   <div className="media">
//                                     <svg
//                                       xmlns="http://www.w3.org/2000/svg"
//                                       width="16"
//                                       height="16"
//                                       fill="currentColor"
//                                       className="bi bi-file-earmark-check"
//                                       viewBox="0 0 16 16"
//                                       title="Unfeatured"
//                                     >
//                                       <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
//                                       <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
//                                     </svg>
//                                     <div className="media-content">
//                                       <h3>Mark as Unfeatured</h3>
//                                     </div>
//                                   </div>
//                                 </a>
//                               )}
//                             </div>
//                             <div className="user-block d-flex">
//                               <div className="image">
//                                 <img
//                                   src={`${feedlst?.ProfilePic}` || defaultImage}
//                                   onError={handleImageError}
//                                   width="32"
//                                   style={{ opacity: "1" }}
//                                   data-demo-src="/images/main-body/1.jpg"
//                                   data-user-popover="1"
//                                   alt=""
//                                 />
//                               </div>
//                               <div className="user-info mt-2">
//                                 <Link
//                                   to={`/Profile/${feedlst?.PostedByGUID}`}
//                                   onClick={(e) => e.stopPropagation()}
//                                   className="atag"
//                                 >
//                                   {feedlst?.PostedBy}
//                                   <span className="time">
//                                     {moment(feedlst?.CreatedDate).format(
//                                       "MMMM Do YYYY, h:mm a",
//                                     )}
//                                   </span>
//                                 </Link>
//                               </div>
//                             </div>
//                             <div
//                               className="dropdown is-spaced is-right is-neutral dropdown-trigger ms-0 d-flex align-items-center"
//                               style={{ gap: "5px" }}
//                             >
//                               {feedlst?.IsFeatured == 1 && (
//                                 <div className="featured-star" key={index}>
//                                   <img
//                                     src="/images/IsFeturedImage.png"
//                                     title="Featured Post"
//                                     data-user-popover="1"
//                                     alt=""
//                                   />
//                                 </div>
//                               )}
//                               <div>
//                                 <div
//                                   className="button"
//                                   onClick={() => toggleVisibility(feedlst.Id)}
//                                 >
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="24"
//                                     height="24"
//                                     viewBox="0 0 24 24"
//                                     fill="none"
//                                     stroke="currentColor"
//                                     strokeWidth="2"
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     className="feather feather-more-vertical"
//                                   >
//                                     <circle cx="12" cy="12" r="1"></circle>
//                                     <circle cx="12" cy="5" r="1"></circle>
//                                     <circle cx="12" cy="19" r="1"></circle>
//                                   </svg>
//                                 </div>
//                               </div>
//                               <div className="dropdown-menu" role="menu">
//                                 <div className="dropdown-content">
//                                   <a className="dropdown-item">
//                                     <div className="media">
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         strokeWidth="2"
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         className="feather feather-bookmark"
//                                       >
//                                         <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
//                                       </svg>
//                                       <div className="media-content">
//                                         <h3>Bookmark</h3>
//                                         <small>
//                                           Add this post to your bookmarks.
//                                         </small>
//                                       </div>
//                                     </div>
//                                   </a>
//                                   <a className="dropdown-item">
//                                     <div className="media">
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         strokeWidth="2"
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         className="feather feather-bell"
//                                       >
//                                         <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
//                                         <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
//                                       </svg>
//                                       <div className="media-content">
//                                         <h3>Notify me</h3>
//                                         <small>Send me the updates.</small>
//                                       </div>
//                                     </div>
//                                   </a>
//                                   <hr className="dropdown-divider" />
//                                   <a className="dropdown-item">
//                                     <div className="media">
//                                       <svg
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         width="24"
//                                         height="24"
//                                         viewBox="0 0 24 24"
//                                         fill="none"
//                                         stroke="currentColor"
//                                         strokeWidth="2"
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         className="feather feather-flag"
//                                       >
//                                         <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
//                                         <line x1="4" y1="22" x2="4" y2="15"></line>
//                                       </svg>
//                                       <div className="media-content">
//                                         <h3>Flag</h3>
//                                         <small>
//                                           In case of inappropriate content.
//                                         </small>
//                                       </div>
//                                     </div>
//                                   </a>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                           <FeedCarousel
//                             templateData={feedlst}
//                             itemIndex={index}
//                             onPassResponse={handleLastName}
//                           />
//                           <div
//                             className="card-footer d-block commentdiv"
//                             onClick={(e) => e.stopPropagation()}
//                           >
//                             <div className="send-output">
//                               <img
//                                 className="pro-img"
//                                 src={userDetails?.ProfileImage || defaultImage}
//                                 onError={handleImageError}
//                                 title={userDetails?.FullName}
//                                 data-user-popover="1"
//                                 alt=""
//                               />
//                               <Commnent
//                                 key={index}
//                                 sendCommentData={FeedPostComment}
//                                 reciveCommentData={feedText}
//                                 employeesList={employee}
//                                 commentType={feedlst?.Id}
//                               />
//                             </div>

//                             {feedlst?.LastComment && (
//                               <div className="feed-comments-bottomdiv">
//                                 <img
//                                   src={
//                                     feedlst?.LastCommentByProfilePic || defaultImage
//                                   }
//                                   onError={handleImageError}
//                                   title={feedlst?.LastCommentByProfilePic}
//                                   data-user-popover="1"
//                                   alt=""
//                                 />
//                                 <div className="comment-textdiv bg-light rounded-start-top-0 rounded">
//                                   <div className="d-flex justify-content-between">
//                                     <h6 className="mb-1">
//                                       <Link
//                                         to={`/Profile/${feedlst?.LastCommentGUID}`}
//                                       >
//                                         {feedlst?.LastCommentBy}
//                                       </Link>
//                                     </h6>
//                                     <small className="ms-2">
//                                       <PostDate
//                                         LastCommentDate={feedlst?.LastCommentDate}
//                                       />
//                                     </small>
//                                   </div>
//                                   <p
//                                     className="small break-text"
//                                     dangerouslySetInnerHTML={renderFeedText(
//                                       feedlst,
//                                     )}
//                                   ></p>
//                                   <p className="like-button">
//                                     <span className="me-2">
//                                       {feedlst?.IsLastCommentLikedByMe ? (
//                                         <span
//                                           onClick={() => FeedLikePost(feedlst)}
//                                           className="hover-like-box"
//                                         >
//                                           <svg
//                                             xmlns="http://www.w3.org/2000/svg"
//                                             width="16"
//                                             height="16"
//                                             fill="currentColor"
//                                             className="bi bi-heart-fill"
//                                             viewBox="0 0 16 16"
//                                           >
//                                             <path
//                                               fillRule="evenodd"
//                                               d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
//                                             />
//                                           </svg>
//                                           {/* 
//                                       <div className="hover-like-area">
//                                         <ul>
//                                           <li>
//                                             <a>
//                                               <img
//                                                 src={userDetails?.ProfilePic}
//                                                 className="user-like-img"
//                                               />
//                                               <span>
//                                                 {userDetails?.FullName}
//                                               </span>
//                                             </a>
//                                           </li>
//                                         </ul>
//                                       </div> */}
//                                         </span>
//                                       ) : (
//                                         <span
//                                           onClick={() =>
//                                             FeedLikePost(feedlst, "Like")
//                                           }
//                                         >
//                                           <i className="fa fa-heart-o like-button"></i>
//                                         </span>
//                                       )}
//                                       <b>
//                                         {feedlst?.LastCommentLikeCount >= 1
//                                           ? feedlst?.LastCommentLikeCount
//                                           : ""}
//                                       </b>
//                                     </span>
//                                     <Link
//                                       to={`/Feed/Post/${feedlst?.GUID}`}
//                                       className="atag"
//                                     >
//                                       <i
//                                         className="fa fa-quote-right"
//                                         aria-hidden="true"
//                                       >
//                                         &nbsp;
//                                       </i>
//                                     </Link>
//                                     <span className="like-overlay"></span>
//                                   </p>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </InfiniteScroll>
//           )}
//           {isSecondLoading && <p>Loading....</p>}
//           <div
//             className="modal fade custom-modal-area"
//             id="report-img"
//             tabIndex="-1"
//             aria-hidden="true"
//           >
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content add-editexperience">
//                 <div className="modal-header">
//                   <img
//                     src="/images/org-img/leave/popup-backimg.png"
//                     className="backimg"
//                   />
//                   <div className="img">
//                     <img src="/images/popup-icons/report.png" />
//                   </div>
//                   <button
//                     type="button"
//                     className="btn-close m-auto"
//                     data-bs-dismiss="modal"
//                     onClick={() => handalClosePopup}
//                   ></button>
//                 </div>
//                 <div className="modal-body ">
//                   <h5 className="modal-title text-center"> Do you sure report ?</h5>
//                   <form>
//                     <div className="row  mt-4 gx-3 gy-2">
//                       <div className="form-group mb-3 ">
//                         <label className="form-label">
//                           Subject Name<i className="inValidError">*</i>
//                         </label>
//                         <input
//                           type="text"
//                           name="subject"
//                           className={
//                             "form-control" +
//                             (reportPostForm.errors.subject &&
//                               reportPostForm.touched.subject
//                               ? " is-invalid"
//                               : "")
//                           }
//                           onChange={reportPostForm.handleChange}
//                           value={reportPostForm.values.subject}
//                           placeholder="Subject Name"
//                         />{" "}
//                         <div className="invalid-feedback">
//                           {reportPostForm.errors.subject &&
//                             reportPostForm.touched.subject
//                             ? reportPostForm.errors.subject
//                             : null}
//                         </div>
//                       </div>
//                       <div className="form-group mb-3">
//                         <label className="form-label">
//                           <i className="fa fa-info-circle" aria-hidden="true"></i>{" "}
//                           Help us understand what's happening.
//                           <i className="inValidError">*</i>
//                         </label>
//                         <input
//                           type="text"
//                           name="desc"
//                           className={
//                             "form-control" +
//                             (reportPostForm.errors.desc &&
//                               reportPostForm.touched.desc
//                               ? " is-invalid"
//                               : "")
//                           }
//                           onChange={reportPostForm.handleChange}
//                           value={reportPostForm.values.desc}
//                           placeholder="Description"
//                         />{" "}
//                         <div className="invalid-feedback">
//                           {reportPostForm.errors.desc && reportPostForm.touched.desc
//                             ? reportPostForm.errors.desc
//                             : null}
//                         </div>
//                       </div>
//                       <div className="form-group mb-3 ">
//                         <div className="upload__box">
//                           {uploadedPostImages.length <= 0 && (
//                             <div className="upload__btn-box">
//                               <label className="d-block form-label">
//                                 Upload Doc
//                               </label>
//                               <label className="upload__btn">
//                                 <p className="m-0">
//                                   <i className="fa fa-plus-square-o mr-3"></i>
//                                   Upload Doc
//                                 </p>
//                                 <input
//                                   type="file"
//                                   multiple=""
//                                   data-max_length="20"
//                                   className="upload__inputfile"
//                                   onChange={handleFilePostChange}
//                                 />
//                               </label>
//                             </div>
//                           )}
//                           {uploadedPostImages?.length != 0 && (
//                             <div className="upload__img-wrap">
//                               <div className="upload__img-box">
//                                 <span
//                                   className="closeresume_Report"
//                                   style={{ cursor: "pointer" }}
//                                   onClick={() =>
//                                     handleDeleteImage(uploadedPostImages)
//                                   }
//                                   title="Delete"
//                                 >
//                                   <svg
//                                     xmlns="http://www.w3.org/2000/svg"
//                                     width="20"
//                                     height="20"
//                                     fill="currentColor"
//                                     className="bi bi-x"
//                                     viewBox="0 0 16 16"
//                                   >
//                                     {" "}
//                                     <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
//                                   </svg>
//                                 </span>
//                                 <img src={uploadedPostImages} className="w-100" />
//                               </div>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </form>
//                   <div className="modal-footer m-auto">
//                     <button
//                       type="button"
//                       className="cancelbtn-click"
//                       data-bs-dismiss="modal"
//                       onClick={handalClosePopup}
//                     >
//                       Close
//                     </button>
//                     <button
//                       type="submit"
//                       className="savebtn-click"
//                       onClick={reportPostForm.handleSubmit}
//                     >
//                       Send
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="modal fade" id="add-Publish" >
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content ">
//                 <div className="modal-header position-relative">
//                   <h5 className="modal-title position-relative share-thoughts">
//                     Share your thoughts
//                     <div className="info-tooltip-area2 ">
//                       <img src="/images/org-img/leave/info.svg" className="infoimg" />
//                       <div className="info-tooltip-content info-area">
//                         <div className="purchase-tooltip-content">
//                           Kindly avoid using hashtags and mentions while publishing.
//                         </div>
//                       </div>
//                     </div>
//                   </h5>
//                   <button
//                     onClick={() => ResetFeedFields()}
//                     type="button"
//                     className="btn-close"
//                     data-bs-dismiss="modal"
//                   ></button>
//                 </div>
//                 <div className="modal-body text-center">
//                   <Editor
//                     value={feedArticelText}
//                     onTextChange={(e) => setFeedArticelText(e.htmlValue)}
//                     style={{ height: "320px" }}
//                   />
//                 </div>
//                 <div className="modal-footer ">
//                   <button
//                     type="button"
//                     className="btn btn-block btn-purple"
//                     data-bs-dismiss="modal"
//                     disabled={!isVisible}
//                     onClick={PostFeed}
//                   >
//                     Post
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal fade" id="delete-post">
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content delete-holiday">
//                 <div className="modal-header">
//                   <img
//                     src="/images/org-img/leave/popup-backimg.png"
//                     className="backimg"
//                   />
//                   <div className="img">
//                     <img src="/images/org-img/leave/trash.png" />
//                   </div>
//                 </div>
//                 <div className="modal-body text-center">
//                   <strong className="modal-title">Are you sure?</strong>
//                   <p>Do you really want to delete this post?</p>
//                 </div>
//                 <div className="modal-footer m-auto">
//                   <button
//                     type="button"
//                     className="cancelbtn-click"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="deletebtn-click"
//                     data-bs-dismiss="modal"
//                     onClick={() => DeleteFeedPost()}
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="modal fade" id="featured-post">
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content featured-post-confirmation">
//                 <div className="modal-header">
//                   <img
//                     src="/images/org-img/leave/popup-backimg.png"
//                     className="backimg"
//                   />
//                   <div className="img">
//                     <img src="/images/popup-icons/featured-post.png" />
//                   </div>
//                 </div>
//                 <div className="modal-body text-center">
//                   <strong className="modal-title">Are you sure?</strong>
//                   <p>
//                     Do you really want to {isFeaturedType == 1 && "feature"}{" "}
//                     {isFeaturedType == 2 && "unfeature"} this post ?
//                   </p>
//                 </div>
//                 <div className="modal-footer m-auto">
//                   <button
//                     type="button"
//                     className="cancelbtn-click"
//                     data-bs-dismiss="modal"
//                   >
//                     Cancel
//                   </button>
//                   {isFeaturedType == 1 && (
//                     <button
//                       type="button"
//                       className="savebtn-click"
//                       data-bs-dismiss="modal"
//                       onClick={() => PostMarkFeatured()}
//                     >
//                       Feature
//                     </button>
//                   )}{" "}
//                   {isFeaturedType == 2 && (
//                     <button
//                       type="button"
//                       className="savebtn-click"
//                       data-bs-dismiss="modal"
//                       onClick={() => PostMarkUnFeatured()}
//                     >
//                       Unfeature
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//         </>

//       )}
//     </div>
//   );
// });
// export default DashboardFeed;


import React, {
  memo,
  startTransition,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { getRawPermissionsArray } from "../../../../Routes/AuthGard/usePermissions";
import {
  deleteFeedPost,
  feedPostComment,
  getFeed,
  getReportPost,
  feedLikePost,
  postMarkFeatured,
  postMarkUnFeatured,
  feedLikeList,
  postFeed,
} from "../Services/DashboardServices";
import moment from "moment";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import InfiniteScroll from "react-infinite-scroll-component";
import FeedPost from "./FeedPost";
import { PostDate } from "../CommonComponents/PostDate";
import Commnent from "../../../../Services/Comment/comment";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton from "react-loading-skeleton";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import { setFeedRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { useDispatch, useSelector } from "react-redux";
import TosterService from "../../../../Services/Toster-Service/TosterService";
import { Editor } from "primereact/editor";
import { debounce } from "lodash";
import { getTrans as T } from "../../../../Shared/Language";
import LoginLoader from "../../../../Shared/Sidebar/LoginLoader";
import DashboardTask from "../CommonComponents/DashboardTask";
const FeedCarousel = React.lazy(() =>
  import("./FeedCarousel").then((module) => ({ default: module.FeedCarousel })),
);
const defaultImage = "/images/placeholder_profile.png";

let MakeFeaturedFeedId;
let isFeaturedType;
// const DashboardFeed = memo(() => {
const DashboardFeed = memo(({ activityData = {}, loading: propLoading = false }) => {

  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let history = useHistory();
  const toaster = useContext(TostMsg);
  const [isLoading, setIsLoading] = useState(true);
  const [isSecondLoading, setSecondLoading] = useState(false);
  const [feedLst, setFeedLst] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [feedText, setFeedText] = useState("");
  const [postFile, setPostFile] = useState(null);
  const [uploadedPostImages, setUploadedPostImages] = useState([]);
  const [feedId, setFeedId] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  let userPermissions = getRawPermissionsArray();
  const [feedEdit, setFeedEdit] = useState(false);
  const [feedReport, setFeedReport] = useState(false);
  const [feedDelete, setFeedDelete] = useState(false);
  const [feedFeatured, setFeedFeatured] = useState(false);
  const [editFeedLst, setEditFeedLst] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const dispatch = useDispatch();
  const toster = useContext(TostMsg);
  const [feedArticelText, setFeedArticelText] = useState("");
  const [editFeedArticleId, setEditFeedArticleId] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [dashboardFeedPost, setDashboardFeedPost] = useState(false);
  const [dashboardFeedRead, setDashboardFeedRead] = useState(false);
  const [dashboardTaskRead, setDashboardTaskRead] = useState(false);
  const [isActiveFeedPost, setIsActiveFeedPost] = useState(false);
  const SideBarFeedRequestData = useSelector(
    (state) => state.createPostData.postRequestData,
  );

  useEffect(() => {
    if (SideBarFeedRequestData?.StatusCode === 2000) {
      GetFeed(true);
    }
    fetchData();
    FeedLikeListData();
    permissionFeedGranted();
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [SideBarFeedRequestData]);

  useEffect(() => {
    if (editFeedArticleId?.FeedText) {
      setIsVisible(true);
    } else if (feedArticelText) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [editFeedArticleId, feedArticelText]);

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown")) {
      setVisibleId(null);
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handalClosePopup = () => {
    document.querySelector("#report-img .btn-close")?.click();
    reportPostForm.resetForm();
  };

  const addReportPost = () => {
    reportPostForm.resetForm();
  };

  const handleDeleteImage = (uploadedPostImages) => {
    setUploadedPostImages([]);
  };

  const handleResponseFromB = (response) => {
    if (response) {
      setFeedLst([]);
      setPage(1);
      setHasMore(true);
      dispatch(setFeedRequestData(response));
      GetFeed(true);
    }
  };

  const fetchData = async () => {
    await GetFeed(false);
    await fetchEmployeeData();
  };

  const [visibleId, setVisibleId] = useState(null);
  const toggleVisibility = (id) => {
    setVisibleId((prevId) => (prevId === id ? null : id));
  };

  const handleLastName = (lst, type) => {
    setFeedLst((prevFeed) =>
      prevFeed.map((post) => {
        if (post.Id !== lst.Id) return post;

        const reactionsArray = post.Reactions
          ? post.Reactions.toString().split(",")
          : [];

        // REMOVE reaction (toggle off)
        if (post.MyReaction === type) {
          return {
            ...post,
            MyReaction: "",
            Reactions: reactionsArray.filter((r) => r !== type),
            LikesCount: post.LikesCount - 1,
            IsLikedByMe: 0,
          };
        }

        // ADD first reaction
        if (!post.MyReaction) {
          return {
            ...post,
            MyReaction: type,
            Reactions: [...reactionsArray, type],
            LikesCount: post.LikesCount + 1,
            IsLikedByMe: 1,
          };
        }

        // CHANGE reaction
        const updatedReactions = reactionsArray.map((r) =>
          r === post.MyReaction ? type : r,
        );

        return {
          ...post,
          MyReaction: type,
          Reactions: updatedReactions,
        };
      }),
    );
  };

  async function GetFeed(reset = false) {
    if (isFetching) return;
    setIsFetching(true);
    if (reset) {
      setIsLoading(true);
    } else {
      setSecondLoading(true);
    }
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      EmpGUID: "",
      FeedId: 0,
      FeedGUID: "",
      IsFeatures: 0,
      pageNumber: reset ? 1 : page,
      pageSize: 25,
      LoggedInUserId: userDetails?.EmpId,
    };

    try {
      const Feedlst = await getFeed(body);
      const feedlist =
        Feedlst?.Data?.map((el) => ({ ...el, isChecked: !!el.IsFeatures })) ||
        [];
      if (reset) {
        setFeedLst(feedlist);
        setPage(2);
        setHasMore(feedlist.length === 25);
      } else {
        setFeedLst((prev) => [...prev, ...feedlist]);
        setPage((prev) => prev + 1);
        setHasMore(feedlist.length === 25);
      }
    } catch (error) {
      toaster.current.error(ERROR_LIST?.DashboardFeed);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
      setSecondLoading(false);
    }
  }

  async function DeleteFeedPost() {
    if (!deleteId || isNaN(deleteId)) {
      toaster.current.error("Invalid feed ID for deletion.");
      return;
    }

    const previousFeedLst = [...feedLst];
    setFeedLst((prev) => {
      const newList = prev.filter((item) => item.Id !== deleteId);
      return newList;
    });

    try {
      const body = { Id: deleteId };
      await deleteFeedPost(body);
      dispatch(setFeedRequestData(body));
      toaster.current.success("Feed deleted successfully.");
      setDeleteId(null);
    } catch (error) {
      toaster.current.error("Failed to delete feed post.");
      setFeedLst(previousFeedLst);
    }
  }

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 5000000,
      EmployeeId: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList.Data);
    } catch (error) { }
  }

  async function FeedPostComment(Feedlst, mentionedArr, CommentText, FeedId) {
    if (FeedId) {
      const body = {
        FeedId: FeedId,
        EmpId: userDetails?.EmpId,
        ParentCommentId: 0,
        Comment: CommentText,
        PostMentions: mentionedArr,
      };

      try {
        await feedPostComment(body);
        setFeedLst((prev) =>
          prev.map((item, idx) =>
            item.Id === FeedId
              ? {
                ...item,
                LastComment: CommentText,
                LastCommentBy: userDetails?.FullName,
                LastCommentById: userDetails?.EmpId,
                LastCommentByProfilePic: userDetails?.ProfileImage,
                LastCommentDate: currentTime,
                LastCommentGUID: userDetails?.GUID,
                PostMentions: mentionedArr,
                TotalComments: item.TotalComments + 1,
              }
              : idx === feedLst?.findIndex((f) => f.FeedId === FeedId)
                ? { ...item, LastComment: CommentText }
                : item,
          ),
        );
        setFeedText("");
        setPage(1);
        setHasMore(true);
      } catch (error) {
        toaster.current.error(ERROR_LIST?.FeedPostOnComment);
      }
    } else {
      toaster.current.error(ERROR_LIST?.FeedPostOnComment);
    }
  }

  const reportPostValidation = Yup.object().shape({
    subject: Yup.string().required("Subject name is required."),
    desc: Yup.string().required("Title desc is required."),
    url: Yup.string(),
  });

  const reportPostForm = useFormik({
    initialValues: {
      subject: "",
      desc: "",
      url: "",
    },
    validationSchema: reportPostValidation,
    onSubmit: async (data) => {
      setIsLoading(true);
      data.PostId = feedId ?? 0;
      data.EmpId = userDetails?.EmpId;
      let reportPostList = await getReportPost(data);
      try {
        if (reportPostList) {
          reportPostForm.resetForm();
          setUploadedPostImages([]);
          toaster.current.success("Report post successfully");
          handalClosePopup();
          document.querySelector("#report-img .btn-close")?.click();
          setIsLoading(false);
        }
      } catch (error) {
        toaster.current.error("Something went wrong");
        setIsLoading(false);
      }
    },
  });

  const handleFilePostChange = useCallback(async (event) => {
    const selectedFile = await event.target.files[0];
    setPostFile(selectedFile);
  }, []);

  const EditFeedLst = (feedLst) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("feed-org"),
    );
    modal.show();
    setEditFeedLst(null);
    setTimeout(() => setEditFeedLst(feedLst), 0);
  };

  const ResetFeedFields = () => {
    setEditFeedLst(null);
    setTimeout(() => setEditFeedLst("reset"), 0);
  };
  useEffect(() => {
    if (postFile) {
      uploadPostDocFile();
    }
  }, [postFile]);

  async function uploadPostDocFile() {
    if (postFile) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("files", postFile);
      let params = {
        UploadType: UploadFile_KEYS?.Feed,
        RefId: editFeedLst?.Id ?? 0,
      };
      const response = await await uploadDoc(params, formData);
      const data = await response;
      const postFormData = data?.Data[0];
      setUploadedPostImages(data?.Data[0]);
      reportPostForm.setFieldValue("url", postFormData);
      setIsLoading(false);
    } else {
      toaster.current.warn("No file selected");
      setIsLoading(false);
    }
  }

  async function FeedLikePost(lst) {
    const updatedFeedList = feedLst.map((item) => {
      if (item.Id !== lst.Id) return item;
      let updatedItem = { ...item };
      if (item.IsLastCommentLikedByMe == 1) {
        updatedItem = {
          ...item,
          IsLastCommentLikedByMe: Math.max(0, item.IsLastCommentLikedByMe - 1),
          LastCommentLikeCount: Math.max(0, item.LastCommentLikeCount - 1),
        };
      } else {
        updatedItem = {
          ...item,
          IsLastCommentLikedByMe: item.IsLastCommentLikedByMe + 1,
          LastCommentLikeCount: item.LastCommentLikeCount + 1,
        };
      }
      return updatedItem;
    });
    setFeedLst(updatedFeedList);
    let isLike = lst.MyReaction !== "Like";
    const body = {
      FeedId: Number(lst.Id),
      CommentId: lst.LastCommentId || 0,
      ReactionById: userDetails?.EmpId,
      ReactionTypeId: 101,
      Reaction: "Like",
      IsLike: isLike,
    };
    try {
      await feedLikePost(body);
    } catch (error) {
      toaster.current.warn(ERROR_LIST.DashboardLike);
    }
  }

  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    let postMention = text?.PostMentions;
    let FeedText = text?.LastComment;

    let newText = FeedText?.replace(mentionRegex, (mention) => {
      let matchedMention = postMention?.find(
        (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention,
      );
      if (!matchedMention) {
        return mention.replace("@", "");
      }
      return `<a href="/Profile/${matchedMention.MentionedUserId}">${matchedMention.MentionedName}</a>`;
    });

    newText = newText?.replace(hashtagRegex, (hashtag) => {
      return `<a style="color: #c4c6c7">${hashtag}</a>`;
    });

    return { __html: newText };
  };

  function markFeatured(feedId, type) {
    MakeFeaturedFeedId = feedId;
    isFeaturedType = type;
  }

  async function PostMarkFeatured() {
    setIsLoading(true);
    const body = {
      PostId: MakeFeaturedFeedId,
    };
    try {
      await postMarkFeatured(body);
      history?.push("/Feed/Featured");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toaster.current.error(ERROR_LIST?.MakeFeatured);
    }
  }

  function markUnFeatured(feedId, type) {
    MakeFeaturedFeedId = feedId;
    isFeaturedType = type;
  }

  async function PostMarkUnFeatured() {
    const previousFeedLst = [...feedLst];
    setFeedLst((prev) => {
      const newList = prev.map((item) => {
        if (item.Id === MakeFeaturedFeedId) {
          return {
            ...item,
            IsFeatured: 0,
          };
        }
        return item;
      });
      return newList;
    });
    const body = {
      PostId: MakeFeaturedFeedId,
    };
    try {
      await postMarkUnFeatured(body);
    } catch (error) {
      setFeedLst(previousFeedLst);
      toaster.current.error(ERROR_LIST?.MakeFeatured);
    }
  }

  const permissionFeedGranted = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Feed.Edit") {
        setFeedEdit(true);
      } else if (UserPermission.PermissionName == "Feed.Report") {
        setFeedReport(true);
      } else if (UserPermission.PermissionName == "Feed.Delete") {
        setFeedDelete(true);
      } else if (UserPermission.PermissionName == "Feed.Featured") {
        setFeedFeatured(true);
      } else if (UserPermission.PermissionName == "Feed.Read") {
        setDashboardFeedRead(true);
      } else if (UserPermission.PermissionName == "Feed.Post") {
        setDashboardFeedPost(true);
      }
      else if (UserPermission.PermissionName == "Task.Read") {
        setDashboardTaskRead(true);
      }
    });
  };

  async function FeedLikeListData() {
    const body = {
      LoggedInUserId: userDetails?.EmpId,
      FeedId: 438,
      FeedGUID: "",
      CommentId: 10198, //10198,
      pageNumber: 1,
      pageSize: 1000000,
    };
    try {
      let LikeList = await feedLikeList(body);
    } catch (error) {
      TosterService.current.error(ERROR_LIST?.FeedLikePostOnFeedDetails);
    }
  }

  const EditFeedArticleLst = (feedLst) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("add-Publish"),
    );
    modal.show();
    if (feedLst) {
      let cleanText = feedLst?.FeedText || "";
      if (cleanText.startsWith("EditorContent=")) {
        cleanText = cleanText.replace("EditorContent=", "");
      }
      const editArticle = {
        Id: feedLst?.Id ?? 0,
        EmpId: feedLst?.EmpId,
        FeedText: feedLst?.FeedText,
      };
      setEditFeedArticleId(editArticle);
      setFeedArticelText(cleanText);
    }
  };

  const PostFeed = async () => {
    setIsLoading(true);
    //  const finalText = `EditorContent=${feedArticelText || editFeedArticleId?.FeedText || ""}`;
    const text = feedArticelText || editFeedArticleId?.FeedText || "";
    const finalText = text.startsWith("EditorContent=")
      ? text
      : `EditorContent=${text}`;
    const body = {
      Id: editFeedArticleId?.Id ?? 0,
      EmpId: userDetails?.EmpId,
      FeedText: finalText,
      IsCommentEnabled: true,
      IsLikeCountVisible: true,
      CommentVisible: true,
      IsLikeEnabled: true,
      PostMedia: [],
      PostMentions: [],
    };
    try {
      await postFeed(body);
      document.querySelector("#add-Publish .btn-close")?.click();
      toster.current.success("Feed post successfully.");
      GetFeed(false);
      setFeedArticelText("");
      setEditFeedArticleId("");
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST?.DashboardFeaturePost);
    }
  };

  const goToPost = (feedlst) => {
    history.push(`/Feed/Post/${feedlst?.GUID}`);
  };

  return (
    <div>

      {dashboardFeedPost && (
        <div
          className="col-xl-12 topmedia-section mb-3"
          onClick={() => {
            ResetFeedFields();
            startTransition(() => setIsActiveFeedPost(true));
          }}
        >
          <div className="">
            <div className="feed-seach-div">
              <div
                className="left-profile-div"
                // data-bs-toggle="modal"
                // data-bs-target="#feed-org"
                style={{ cursor: "pointer" }}
              >
                <img
                  src={userDetails?.ProfileImage || defaultImage}
                  onError={handleImageError}
                  width="32"
                  data-demo-src="/images/main-body/1.jpg"
                />
                <div className="feed-search">
                  <span className="time">Share your thoughts</span>
                </div>
              </div>
              <div className="right-action-div">
                <ul className="edit-feeds">
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#feed-org"
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-success pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"></path>
                    </svg>
                    Photos
                  </li>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#feed-org"
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-info pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"></path>
                      <path d="M9 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6"></path>
                      <path d="M9 6h.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 7.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 16H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"></path>
                    </svg>
                    Videos
                  </li>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#feed-org"
                    style={{ cursor: "pointer" }}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-warning pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"></path>
                    </svg>
                    Feelings
                  </li>
                  {/* <li
                  data-bs-toggle="modal"
                  data-bs-target="#add-Publish"
                  style={{ cursor: "pointer" }}
                  onClick={() => setFeedArticelText("")}
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    strokeWidth="0"
                    viewBox="0 0 16 16"
                    className="text-warning pe-2"
                    height="20"
                    width="20"
                    data-bs-toggle="modal"
                    data-bs-target="#add-Publish"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M15.964.686a.5.5 0 0 0-.69-.69L.767 7.247a.5.5 0 0 0 .07.92l5.632 2.11 2.11 5.632a.5.5 0 0 0 .92.07z" />
                  </svg>
                  Publish
                </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {dashboardTaskRead && <DashboardTask/>}  */}
      {dashboardTaskRead && <DashboardTask activityData={activityData} loading={propLoading} />}


      {(dashboardFeedRead) && (
        <>
          {isActiveFeedPost && (
            <FeedPost
              returnResponce={handleResponseFromB}
              editFeedLst={editFeedLst}
              isActiveFeedPost={isActiveFeedPost}
              onClose={() => setIsActiveFeedPost(false)}
            />
          )}
          {isLoading ? (
            <Skeleton height={470} width="100%" />
          ) : (
            <InfiniteScroll
              dataLength={feedLst?.length || 0}
              next={() => GetFeed(false)}
              hasMore={hasMore}
              scrollableTarget="scrollableDiv"
            >
              {feedLst?.map((feedlst, index) => (
                <div className="col-xl-12" key={index}>
                  <div
                    className=""
                    style={{ background: "none", boxShadow: "none" }}
                  >
                    <div className="">
                      <div
                        id="feed-post-1"
                        className="card is-post"
                        onClick={() => goToPost(feedlst)}
                      >
                        <div className="content-wrap">
                          <div className="card-heading">
                            <div
                              id="myDIV2"
                              style={{
                                display:
                                  visibleId === feedlst.Id ? "block" : "none",
                              }}
                            >
                              {(feedEdit ||
                                feedlst?.CreatedBy == userDetails?.EmpId) && (
                                  <a
                                    className="dropdown-item"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      feedlst?.FeedText?.includes("EditorContent=")
                                        ? EditFeedArticleLst(feedlst)
                                        : EditFeedLst(feedlst)
                                    }
                                    // onClick={() => EditFeedLst(feedlst)}
                                    aria-expanded="false"
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    data-bs-toggle="modal"
                                    // data-bs-target="#feed-org"
                                    title="Edit"
                                  >
                                    <div className="media">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil-square"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                        />
                                      </svg>
                                      <div className="media-content">
                                        <h3>Edit</h3>
                                      </div>
                                    </div>
                                  </a>
                                )}
                              {(feedDelete ||
                                feedlst?.CreatedBy == userDetails?.EmpId) && (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="dropdown-item"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete-post"
                                    onClick={() => setDeleteId(feedlst?.Id)}
                                  >
                                    <div className="media">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash"
                                        viewBox="0 0 16 16"
                                        title="Delete"
                                      >
                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                        />
                                      </svg>
                                      <div className="media-content">
                                        <h3>Delete</h3>
                                      </div>
                                    </div>
                                  </a>
                                )}
                              {feedlst?.CreatedBy !== userDetails?.EmpId &&
                                feedReport && (
                                  <a
                                    style={{ cursor: "pointer" }}
                                    className="dropdown-item"
                                    data-bs-toggle="modal"
                                    data-bs-target="#report-img"
                                    onClick={() => {
                                      setFeedId(feedlst?.Id);
                                      addReportPost();
                                    }}
                                  >
                                    <div className="media">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-flag mr-2"
                                        title="Report"
                                      >
                                        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                                        <line x1="4" y1="22" x2="4" y2="15"></line>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Report this post</h3>
                                      </div>
                                    </div>
                                  </a>
                                )}
                              {feedFeatured && feedlst?.IsFeatured === 0 && (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="dropdown-item"
                                  data-bs-toggle="modal"
                                  data-bs-target="#featured-post"
                                  onClick={() => markFeatured(feedlst?.Id, 1)}
                                >
                                  <div className="media">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-file-earmark-check"
                                      viewBox="0 0 16 16"
                                      title="Featured"
                                    >
                                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    <div className="media-content">
                                      <h3>Mark as Featured</h3>
                                    </div>
                                  </div>
                                </a>
                              )}
                              {feedFeatured && feedlst?.IsFeatured === 1 && (
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="dropdown-item"
                                  data-bs-toggle="modal"
                                  data-bs-target="#featured-post"
                                  onClick={() => markUnFeatured(feedlst?.Id, 2)}
                                >
                                  <div className="media">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-file-earmark-check"
                                      viewBox="0 0 16 16"
                                      title="Unfeatured"
                                    >
                                      <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                    </svg>
                                    <div className="media-content">
                                      <h3>Mark as Unfeatured</h3>
                                    </div>
                                  </div>
                                </a>
                              )}
                            </div>
                            <div className="user-block d-flex">
                              <div className="image">
                                <img
                                  src={`${feedlst?.ProfilePic}` || defaultImage}
                                  onError={handleImageError}
                                  width="32"
                                  style={{ opacity: "1" }}
                                  data-demo-src="/images/main-body/1.jpg"
                                  data-user-popover="1"
                                  alt=""
                                />
                              </div>
                              <div className="user-info mt-2">
                                <Link
                                  to={`/Profile/${feedlst?.PostedByGUID}`}
                                  onClick={(e) => e.stopPropagation()}
                                  className="atag"
                                >
                                  {feedlst?.PostedBy}
                                  <span className="time">
                                    {moment(feedlst?.CreatedDate).format(
                                      "MMMM Do YYYY, h:mm a",
                                    )}
                                  </span>
                                </Link>
                              </div>
                            </div>
                            <div
                              className="dropdown is-spaced is-right is-neutral dropdown-trigger ms-0 d-flex align-items-center"
                              style={{ gap: "5px" }}
                            >
                              {feedlst?.IsFeatured == 1 && (
                                <div className="featured-star" key={index}>
                                  <img
                                    src="/images/IsFeturedImage.png"
                                    title="Featured Post"
                                    data-user-popover="1"
                                    alt=""
                                  />
                                </div>
                              )}
                              <div>
                                <div
                                  className="button"
                                  onClick={() => toggleVisibility(feedlst.Id)}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="feather feather-more-vertical"
                                  >
                                    <circle cx="12" cy="12" r="1"></circle>
                                    <circle cx="12" cy="5" r="1"></circle>
                                    <circle cx="12" cy="19" r="1"></circle>
                                  </svg>
                                </div>
                              </div>
                              <div className="dropdown-menu" role="menu">
                                <div className="dropdown-content">
                                  <a className="dropdown-item">
                                    <div className="media">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-bookmark"
                                      >
                                        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Bookmark</h3>
                                        <small>
                                          Add this post to your bookmarks.
                                        </small>
                                      </div>
                                    </div>
                                  </a>
                                  <a className="dropdown-item">
                                    <div className="media">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-bell"
                                      >
                                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Notify me</h3>
                                        <small>Send me the updates.</small>
                                      </div>
                                    </div>
                                  </a>
                                  <hr className="dropdown-divider" />
                                  <a className="dropdown-item">
                                    <div className="media">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="feather feather-flag"
                                      >
                                        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                                        <line x1="4" y1="22" x2="4" y2="15"></line>
                                      </svg>
                                      <div className="media-content">
                                        <h3>Flag</h3>
                                        <small>
                                          In case of inappropriate content.
                                        </small>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <Suspense fallback={<div className="carousel-loading" />}>
                            <FeedCarousel
                              templateData={feedlst}
                              itemIndex={index}
                              onPassResponse={handleLastName}
                            />
                          </Suspense>
                          <div
                            className="card-footer d-block commentdiv"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="send-output">
                              <img
                                className="pro-img"
                                src={userDetails?.ProfileImage || defaultImage}
                                onError={handleImageError}
                                title={userDetails?.FullName}
                                data-user-popover="1"
                                alt=""
                              />
                              <Commnent
                                key={index}
                                sendCommentData={FeedPostComment}
                                reciveCommentData={feedText}
                                employeesList={employee}
                                commentType={feedlst?.Id}
                              />
                            </div>

                            {feedlst?.LastComment && (
                              <div className="feed-comments-bottomdiv">
                                <img
                                  src={
                                    feedlst?.LastCommentByProfilePic || defaultImage
                                  }
                                  onError={handleImageError}
                                  title={feedlst?.LastCommentByProfilePic}
                                  data-user-popover="1"
                                  alt=""
                                />
                                <div className="comment-textdiv bg-light rounded-start-top-0 rounded">
                                  <div className="d-flex justify-content-between">
                                    <h6 className="mb-1">
                                      <Link
                                        to={`/Profile/${feedlst?.LastCommentGUID}`}
                                      >
                                        {feedlst?.LastCommentBy}
                                      </Link>
                                    </h6>
                                    <small className="ms-2">
                                      <PostDate
                                        LastCommentDate={feedlst?.LastCommentDate}
                                      />
                                    </small>
                                  </div>
                                  <p
                                    className="small break-text"
                                    dangerouslySetInnerHTML={renderFeedText(
                                      feedlst,
                                    )}
                                  ></p>
                                  <p className="like-button">
                                    <span className="me-2">
                                      {feedlst?.IsLastCommentLikedByMe ? (
                                        <span
                                          onClick={() => FeedLikePost(feedlst)}
                                          className="hover-like-box"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-heart-fill"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                            />
                                          </svg>
                                          {/* 
                                      <div className="hover-like-area">
                                        <ul>
                                          <li>
                                            <a>
                                              <img
                                                src={userDetails?.ProfilePic}
                                                className="user-like-img"
                                              />
                                              <span>
                                                {userDetails?.FullName}
                                              </span>
                                            </a>
                                          </li>
                                        </ul>
                                      </div> */}
                                        </span>
                                      ) : (
                                        <span
                                          onClick={() =>
                                            FeedLikePost(feedlst, "Like")
                                          }
                                        >
                                          <i className="fa fa-heart-o like-button"></i>
                                        </span>
                                      )}
                                      <b>
                                        {feedlst?.LastCommentLikeCount >= 1
                                          ? feedlst?.LastCommentLikeCount
                                          : ""}
                                      </b>
                                    </span>
                                    <Link
                                      to={`/Feed/Post/${feedlst?.GUID}`}
                                      className="atag"
                                    >
                                      <i
                                        className="fa fa-quote-right"
                                        aria-hidden="true"
                                      >
                                        &nbsp;
                                      </i>
                                    </Link>
                                    <span className="like-overlay"></span>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </InfiniteScroll>
          )}
          {isSecondLoading && <p>Loading....</p>}
          <div
            className="modal fade custom-modal-area"
            id="report-img"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content add-editexperience">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/popup-icons/report.png" />
                  </div>
                  <button
                    type="button"
                    className="btn-close m-auto"
                    data-bs-dismiss="modal"
                    onClick={() => handalClosePopup}
                  ></button>
                </div>
                <div className="modal-body ">
                  <h5 className="modal-title text-center"> Do you sure report ?</h5>
                  <form>
                    <div className="row  mt-4 gx-3 gy-2">
                      <div className="form-group mb-3 ">
                        <label className="form-label">
                          Subject Name<i className="inValidError">*</i>
                        </label>
                        <input
                          type="text"
                          name="subject"
                          className={
                            "form-control" +
                            (reportPostForm.errors.subject &&
                              reportPostForm.touched.subject
                              ? " is-invalid"
                              : "")
                          }
                          onChange={reportPostForm.handleChange}
                          value={reportPostForm.values.subject}
                          placeholder="Subject Name"
                        />{" "}
                        <div className="invalid-feedback">
                          {reportPostForm.errors.subject &&
                            reportPostForm.touched.subject
                            ? reportPostForm.errors.subject
                            : null}
                        </div>
                      </div>
                      <div className="form-group mb-3">
                        <label className="form-label">
                          <i className="fa fa-info-circle" aria-hidden="true"></i>{" "}
                          Help us understand what's happening.
                          <i className="inValidError">*</i>
                        </label>
                        <input
                          type="text"
                          name="desc"
                          className={
                            "form-control" +
                            (reportPostForm.errors.desc &&
                              reportPostForm.touched.desc
                              ? " is-invalid"
                              : "")
                          }
                          onChange={reportPostForm.handleChange}
                          value={reportPostForm.values.desc}
                          placeholder="Description"
                        />{" "}
                        <div className="invalid-feedback">
                          {reportPostForm.errors.desc && reportPostForm.touched.desc
                            ? reportPostForm.errors.desc
                            : null}
                        </div>
                      </div>
                      <div className="form-group mb-3 ">
                        <div className="upload__box">
                          {uploadedPostImages.length <= 0 && (
                            <div className="upload__btn-box">
                              <label className="d-block form-label">
                                Upload Doc
                              </label>
                              <label className="upload__btn">
                                <p className="m-0">
                                  <i className="fa fa-plus-square-o mr-3"></i>
                                  Upload Doc
                                </p>
                                <input
                                  type="file"
                                  multiple=""
                                  data-max_length="20"
                                  className="upload__inputfile"
                                  onChange={handleFilePostChange}
                                />
                              </label>
                            </div>
                          )}
                          {uploadedPostImages?.length != 0 && (
                            <div className="upload__img-wrap">
                              <div className="upload__img-box">
                                <span
                                  className="closeresume_Report"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteImage(uploadedPostImages)
                                  }
                                  title="Delete"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="currentColor"
                                    className="bi bi-x"
                                    viewBox="0 0 16 16"
                                  >
                                    {" "}
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                  </svg>
                                </span>
                                <img src={uploadedPostImages} className="w-100" />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="modal-footer m-auto">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                      onClick={handalClosePopup}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      className="savebtn-click"
                      onClick={reportPostForm.handleSubmit}
                    >
                      Send
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal fade" id="add-Publish">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content ">
                <div className="modal-header position-relative">
                  <h5 className="modal-title position-relative share-thoughts">
                    Share your thoughts
                    <div className="info-tooltip-area2 ">
                      <img src="/images/org-img/leave/info.svg" className="infoimg" />
                      <div className="info-tooltip-content info-area">
                        <div className="purchase-tooltip-content">
                          Kindly avoid using hashtags and mentions while publishing.
                        </div>
                      </div>
                    </div>
                  </h5>
                  <button
                    onClick={() => ResetFeedFields()}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>
                <div className="modal-body text-center">
                  <Editor
                    value={feedArticelText}
                    onTextChange={(e) => setFeedArticelText(e.htmlValue)}
                    style={{ height: "320px" }}
                  />
                </div>
                <div className="modal-footer ">
                  <button
                    type="button"
                    className="btn btn-block btn-purple"
                    data-bs-dismiss="modal"
                    disabled={!isVisible}
                    onClick={PostFeed}
                  >
                    Post
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="delete-post">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content delete-holiday">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/org-img/leave/trash.png" />
                  </div>
                </div>
                <div className="modal-body text-center">
                  <strong className="modal-title">Are you sure?</strong>
                  <p>Do you really want to delete this post?</p>
                </div>
                <div className="modal-footer m-auto">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="deletebtn-click"
                    data-bs-dismiss="modal"
                    onClick={() => DeleteFeedPost()}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="featured-post">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content featured-post-confirmation">
                <div className="modal-header">
                  <img
                    src="/images/org-img/leave/popup-backimg.png"
                    className="backimg"
                  />
                  <div className="img">
                    <img src="/images/popup-icons/featured-post.png" />
                  </div>
                </div>
                <div className="modal-body text-center">
                  <strong className="modal-title">Are you sure?</strong>
                  <p>
                    Do you really want to {isFeaturedType == 1 && "feature"}{" "}
                    {isFeaturedType == 2 && "unfeature"} this post ?
                  </p>
                </div>
                <div className="modal-footer m-auto">
                  <button
                    type="button"
                    className="cancelbtn-click"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  {isFeaturedType == 1 && (
                    <button
                      type="button"
                      className="savebtn-click"
                      data-bs-dismiss="modal"
                      onClick={() => PostMarkFeatured()}
                    >
                      Feature
                    </button>
                  )}{" "}
                  {isFeaturedType == 2 && (
                    <button
                      type="button"
                      className="savebtn-click"
                      data-bs-dismiss="modal"
                      onClick={() => PostMarkUnFeatured()}
                    >
                      Unfeature
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

        </>

      )}
    </div>
  );
});
export default DashboardFeed;
